export default __webpack_public_path__ + "static/812-02b9e6fa60cf5c0c97f6beec4ef088b3.gif";